import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor, HttpErrorResponse,
} from '@angular/common/http';
import { Router } from "@angular/router";
import { LoginService } from "@core/services/login/login.service";
import { Observable, tap } from 'rxjs';

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {

    constructor(private router: Router, private loginService: LoginService) {
    }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(tap(() => {
        }, (err: any) => {
            if (err instanceof HttpErrorResponse) {
                if (err.status === 401) {
                    localStorage.clear();
                    this.router.navigate(["/"]);
                    this.loginService.logout();
                }
            }
        }));
    }
}
